<template>
  <AudioSearch
    :icon="icon"
    :label="label"
    :title="title"
    :route="route"
    :color="color"
    :status="status"
    :show-revisor="true"
  />
</template>

<script>
import menuConfig from '@/components/menuConfig'
import AudioSearch from '@/views/Dashboard/AudioSearch'
import {
  CODE_AUDIOS_EXAM,
  ROUTE_AUDIOS_EXAM
} from '@/constants'

export default {
  components: {
    AudioSearch
  },

  data () {
    const status = CODE_AUDIOS_EXAM
    const { icon, title, label, route, color } = menuConfig.find(({ route }) => route === ROUTE_AUDIOS_EXAM)
    return { icon, title, label, route, color, status }
  }
}
</script>
